import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import References from "./pages/References";
import ReferenceDetail from "./pages/ReferenceDetail";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import Admin from "./pages/Admin";

const ServiceSlugRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/hizmetlerimiz/${slug}`} replace />;
};

const Layout = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hizmetlerimiz" element={<Services />} />
          <Route path="/hizmetlerimiz/:slug" element={<ServiceDetail />} />
          {/* Legacy URL redirects — client-side fallback; canonical fix is server/CDN HTTP 301 */}
          <Route path="/hizmetler" element={<Navigate to="/hizmetlerimiz" replace />} />
          <Route path="/hizmetler/:slug" element={<ServiceSlugRedirect />} />
          <Route path="/stratejik-dijital-danismanlik" element={<Navigate to="/hizmetlerimiz/stratejik-donusum-danismanlik" replace />} />
          <Route path="/dijital-donusum" element={<Navigate to="/hizmetlerimiz/stratejik-donusum-danismanlik" replace />} />
          <Route path="/dijital-donusum.html" element={<Navigate to="/hizmetlerimiz/stratejik-donusum-danismanlik" replace />} />
          <Route path="/synology-nas" element={<Navigate to="/blog/synology-nas-ile-guvenli-veri-yonetimi" replace />} />
          <Route path="/universal-print.html" element={<Navigate to="/blog/universal-print-ile-yazici-maliyetlerini-dusurmek" replace />} />
          <Route path="/yeni_anasayfa" element={<Navigate to="/" replace />} />
          <Route path="/sample-page" element={<Navigate to="/" replace />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/referanslar" element={<References />} />
          <Route path="/referanslar/:slug" element={<ReferenceDetail />} />
          <Route path="/gizlilik" element={<Privacy />} />
          <Route path="/kullanim-kosullari" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App bg-white">
          <BrowserRouter>
            <Layout />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
